<template>
  <div class="container">
    <div :class="{ 'hover-search-fix': topSearchShow }"></div>
    <Spin fix v-if="modelFormShow"></Spin>
    <div class="SaaSbanner">
      <img :src="require('@/assets/images/scmbanner3.png')" />
    </div>
    <div class="SaaScontent">
      <div class="SaaStitle flex flex-v flex-align-center">
        <p class="p1">智慧风控系统核心能力</p>
      </div>
      <div style="padding: 20px">
        <el-row :gutter="20">
          <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6"
                  v-for="(item, index) in SaaSclist"
                  :key="index">
            <div class="SaaScitem flex flex-v flex-align-center">
              <img :src="item.img" width="65" height="65" class="xt" />
              <p class="p1">{{ item.title }}</p>
              <p class="p2">{{ item.content }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
      
    </div>
    <div class="SaaSCard">
      <div class="SaaSXITONG">
        <img class="wnsxbg" :src="require('@/assets/images/wnsxbg.png')" />
        <div class="SaaStitle flex flex-v flex-align-center">
          <p class="p1" style="margin-top:30px;">智慧风控系统能为你实现</p>
        </div>
        <div class="SaaSXITONGBOX flex flex-l flex-pack-justify">
          <div class="sl flex flex-v">
            <div
              v-for="(item, index) in Cardlist"
              @click="setCardinfo(item)"
              :key="index"
              class="slitem flex flex-v"
              :class="{ slsjx: Cardinfo.id == item.id }"
            >
              <!-- <div class="slitemsjx"></div> -->
              <img :src="require('@/assets/images/sltop.png')" class="sltop" />
              <img
                v-if="Cardinfo.id == item.id"
                :src="item.checkimg"
                :class="'sl0' + (index + 1)"
              />
              <img v-else :src="item.numimg" :class="'sl0' + (index + 1)" />
              <p class="p1">{{ item.title }}</p>
            </div>
          </div>
          <div class="sr flex flex-v">
            <div class="srbox">
              <img :src="Cardinfo.img" width="820" height="380" />
            </div>
            <div class="srcontent flex flex-v">
              <p class="p1">{{ Cardinfo.title }}</p>
              <p class="p2">{{ Cardinfo.content }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="SaaStitle flex flex-v flex-align-center">
        <p class="p1">供应链管理系统适用行业</p>
      </div>
      <div class="Cardfooter flex flex-l flex-pack-justify">
        <div class="Cardleft flex flex-v flex-pack-justify">
          <div class="Cardt flex flex-l flex-pack-justify">
            <div class="Carditem">
              <img
                :src="require('@/assets/images/Cardfooter01.png')"
                width="285"
                height="230"
                class="Cardfooterimg"
              />
              <div class="CardfooterMask flex-text">
                <p>化工/工业</p>
              </div>
            </div>
            <div class="Carditem">
              <img
                :src="require('@/assets/images/Cardfooter02.png')"
                width="285"
                height="230"
                class="Cardfooterimg"
              />
              <div class="CardfooterMask flex-text">
                <p>建筑建材</p>
              </div>
            </div>
          </div>
          <div class="Cardbottom flex flex-l flex-pack-justify">
            <div class="Cardbottom-l flex flex-v">
              <div class="Carditem2">
                <img
                  :src="require('@/assets/images/Cardfooter03.png')"
                  width="285"
                  height="480"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>原材料</p>
                </div>
              </div>
            </div>
            <div class="Cardbottom-r flex flex-v flex-pack-justify">
              <div class="Carditem">
                <img
                  :src="require('@/assets/images/Cardfooter04.png')"
                  width="285"
                  height="230"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>快消品</p>
                </div>
              </div>
              <div class="Carditem">
                <img
                  :src="require('@/assets/images/Cardfooter05.png')"
                  width="285"
                  height="230"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>医药行业</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="Cardright flex flex-v flex-pack-justify">
          <div class="Cardt flex flex-l flex-pack-justify">
            <div class="Carditem">
              <img
                :src="require('@/assets/images/Cardfooter06.png')"
                width="285"
                height="230"
                class="Cardfooterimg"
              />
              <div class="CardfooterMask flex-text">
                <p>农林副业</p>
              </div>
            </div>
            <div class="Carditem">
              <img
                :src="require('@/assets/images/Cardfooter07.png')"
                width="285"
                height="230"
                class="Cardfooterimg"
              />
              <div class="CardfooterMask flex-text">
                <p>环保</p>
              </div>
            </div>
          </div>
          <div class="Cardbottom flex flex-v flex-pack-justify">
            <div class="Cardbottom-l flex flex-v">
              <div class="Carditem3">
                <img
                  :src="require('@/assets/images/Cardfooter08.png')"
                  width="590"
                  height="230"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>机械设备</p>
                </div>
              </div>
            </div>
            <div class="Cardbottom-r flex flex-l flex-pack-justify">
              <div class="Carditem">
                <img
                  :src="require('@/assets/images/Cardfooter09.png')"
                  width="285"
                  height="230"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>钢铁行业</p>
                </div>
              </div>
              <div class="Carditem">
                <img
                  :src="require('@/assets/images/Cardfooter10.png')"
                  width="285"
                  height="230"
                  class="Cardfooterimg"
                />
                <div class="CardfooterMask flex-text">
                  <p>更多行业</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="SaaSfooter flex flex-l">
      <div class="SaaSfl flex flex-v flex-align-center">
        <img
          :src="require('@/assets/images/SaaSflimg.png')"
          class="SaaSflimg"
        />
        <p class="pp">1v1按需求定制个性化方案，全程360°为您服务</p>
        <!-- <div class="SaaSflbox flex flex-l flex-pack-justify">
          <div class="flex-text SaaSflitem">
            <img
              :src="require('@/assets/images/dhico.png')"
              width="26"
              height="23"
              class="dhico"
            />
            <p class="p1">0512-56308111</p>
          </div>
          <div class="sline">|</div>
          <div class="flex-text SaaSflitem">
            <img
              :src="require('@/assets/images/dhico2.png')"
              width="20"
              height="20"
              class="dhico"
            />
            <p class="p2">赵经理181-5113-1688</p>
          </div>
        </div> -->
      </div>
      <div class="SaaSfr">
        <img
          :src="require('@/assets/images/SaaSfrimg.png')"
          class="SaaSfrimg"
        />
      </div>
    </div>
    <!-- 底部栏 -->
    <BaseFooter></BaseFooter>
    <!--  -->
  </div>
</template>

<script>
export default {
  name: "Index",
  mounted() {
    var navid = this.$route.params.navid;
    if (navid) this.navid = navid;
    // this.getIndexData();
    let that = this;
    window.onscroll = function () {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(top)
      if (top > 37) {
        that.topSearchShow = true;
      } else {
        that.topSearchShow = false;
      }
    };

    window.scrollTo(0, 0);
  },
  data() {
    return {
      bannerlist: [
        { img: require("@/assets/images/scmbanner.png") },
        { img: require("@/assets/images/scmbanner2.png") },
        { img: require("@/assets/images/scmbanner3.png") },
        { img: require("@/assets/images/scmbanner4.png") },
      ],
      Cardinfo: {
        id:0,
        numimg: require("@/assets/images/sl01b.png"),
        checkimg: require("@/assets/images/sl01.png"),
        img: require("@/assets/images/cardbg3.png"),
        title: "分类数据以进行风险评估",
        content:
          "对数据进行分类，以便可以检查其敏感性。这将帮助设置算法参数，从而以更积极的方式进行风险评估。数据可分类为：公共数据、私人数据、受限制的数据",
      },
      Cardlist: [
        {
          id:0,
          numimg: require("@/assets/images/sl01b.png"),
          checkimg: require("@/assets/images/sl01.png"),
          img: require("@/assets/images/cardbg3.png"),
          title: "分类数据以进行风险评估",
          content:
            "对数据进行分类，以便可以检查其敏感性。这将帮助设置算法参数，从而以更积极的方式进行风险评估。数据可分类为：公共数据、私人数据、受限制的数据",
        },
        {
          id:1,
          numimg: require("@/assets/images/sl02b.png"),
          checkimg: require("@/assets/images/sl02.png"),
          img: require("@/assets/images/cardbg4.png"),
          title: "多种商业智能算法",
          content:
            "机器模型具有认知行为的能力，千万次预测分析并产生可靠的输出。预测性编程可确保以数据为依据的准确决策，这将影响商业企业的成功。",
        },
        {
          id:2,
          numimg: require("@/assets/images/sl03b.png"),
          checkimg: require("@/assets/images/sl03.png"),
          img: require("@/assets/images/cardbg5.png"),
          title: "风险评估后的性能测试和报告",
          content:
            "风险评估报告的特点是主动性、前瞻性、计划性和时效性，通过风险分析评估、风险控制管理、风险监控更新三个主要阶段进行法律风险评估。三个阶段既相互独立，又相互衔接、协调统一，共同构成科学的动态闭环运行体系",
        },
      ],
      SaaSclist: [
        {
          img: require("@/assets/images/khjd.png"),
          title: "客户尽调",
          content:
            "在新客准入、业务建立、客户风险评级、定期专项排查等场景中，基于第三方的数据优势，借助机器学习、人工智能等技术，实现多维度信息识别与交叉验证，给予强有力功能支撑和协作",
        },
        {
          img: require("@/assets/images/fkpg.png"),
          title: "风控评估模型",
          content:
            "风险评估的最有效的数据模型，融合组织内部和外部数据流。对数据进行分类，以便可以检查其敏感性检查安全漏洞或故意违规，这将帮助设置算法参数",
        },
        {
          img: require("@/assets/images/fkbg.png"),
          title: "风险评估报告",
          content:
            "风险评估报告的特点是主动性、前瞻性、计划性和时效性，通过风险分析评估、风险控制管理、风险监控更新三个主要阶段进行法律风险评估，构成科学的动态闭环运行体系",
        },
        {
          img: require("@/assets/images/fxgl.png"),
          title: "风险管理",
          content:
            "搭建线上线下风控模块，从材料审核、项目审批等多个环节进行科学管理",
        },
        {
          img: require("@/assets/images/fxyj.png"),
          title: "风险预警",
          content:
            "实时更新欺诈信息库，定期对存量用户检测，及时发现跨平台逾期、多头借贷、用户异动等风险",
        },
        {
          img: require("@/assets/images/sjfx.png"),
          title: "数据分析",
          content:
            "使用数据分析进行风险评估不仅限于识别敏感数据所在的安全系统中的漏洞。这也意味着要从数据盗窃中识别出潜在的未来风险",
        },
        
      ],
      navid: 0,
      topSearchShow: false, // 滚动后顶部搜索栏展示
      modelFormShow: false,
    };
  },
  // created(){

  // },
  methods: {
    setCardinfo(item) {
      if (item) {
        this.Cardinfo = item;
      } else {
        this.Cardinfo = {
          id:0,
          numimg: require("@/assets/images/sl01b.png"),
          checkimg: require("@/assets/images/sl01.png"),
          img: require("@/assets/images/cardbg3.png"),
          title: "分类数据以进行风险评估",
          content:
            "对数据进行分类，以便可以检查其敏感性。这将帮助设置算法参数，从而以更积极的方式进行风险评估。数据可分类为：公共数据、私人数据、受限制的数据",
        };
      }
    }
  },
  components: {
  },
};
</script>

<style scoped lang="scss">
.container {
  box-sizing: border-box;
  background-color: rgba(250, 250, 250, 1);
  transition: 0.35s;
  [data-theme="dark"] & {
      background-color: #1d1d1d;
  }
  [data-theme="light"] & {
      background-color:  rgba(250, 250, 250, 1);
  }
  position: relative;
}
.SaaSbanner {
  width: 100%;
  height: 400px;
  overflow: hidden;
  position: relative;
  // margin-bottom: 82px;
  > img {
    display: block;
    margin: 0 auto;
    width: 1920px;
    height: 400px;
  }
  .SaaSCar {
    width: 1276px;
    height: 118px;
    position: absolute;
    left: 50%;
    bottom: -80px;
    transform: translate(-50%, 0);

    .Caritem {
      width: 304px;
      height: 118px;
      padding: 16px 20px;
      background: #ffffff;
      box-shadow: 0px 4px 20px 1px rgba(0, 0, 0, 0.04);
      .p1 {
        margin-top: 4px;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
      }

      .p2 {
        margin-top: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
      }
      > img {
        margin-right: 20px;
      }
      .zy1 {
        width: 90px;
        height: 87px;
      }
      .zy2 {
        width: 104px;
        height: 84px;
      }
      .zy3 {
        width: 107px;
        height: 70px;
      }
      .zy4 {
        width: 90px;
        height: 70px;
      }
    }
  }
}
.SaaScontent {
  max-width: 1200px;
  margin: 0 auto 10px;
  .SaaStitle {
    width: 100%;
    .p1 {
      margin-top: 50px;
      font-size: 26px;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
    }
    .p2 {
      margin-top: 10px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 21px;
    }
  }
  .SaaScitem {
      // cursor: pointer;
      // margin-right: 20px;
      margin-bottom: 20px;
      position: relative;
      width: 100%;
      height: 236px;
      background: #ffffff;
      // box-shadow: 0px 4px 20px 1px rgba(0, 0, 0, 0.04);
      padding: 30px 11px 30px 10px;
      box-sizing: border-box;
      .xt {
        width: 65px;
        height: 65px;
      }
      .p1 {
        margin-top: 20px;
        width: 100%;
        text-align: center;
        // margin-top: 10px;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
      }
      .p2 {
        margin-top: 15px;
        width: 100%;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
      }
      .xtmore {
        position: absolute;
        bottom: 20px;
        right: 20px;
        height: 16px;
        .p3 {
          font-size: 12px;
          font-weight: 400;
          color: #ff7f50;
          line-height: 16px;
        }
        .jtimg {
          width: 4px;
          height: 8px;
          margin-left: 5px;
        }
      }
    }
  .SaaSclist {
    margin-top: 80px;
    width: 1220px;
    flex-wrap: wrap;
    
  }
  .fwhy {
    width: 1176px;
    height: 440px;
    margin-left: 12px;
    margin-top: 50px;
  }
}
.SaaSCard {
  width: 100%;
  background-color: #fff;
  .SaaSXITONG {
    width: 100%;
    height: 687px;
    position: relative;
    .wnsxbg {
      width: 1920px;
      max-width: 100%;
      height: 687px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .SaaStitle {
      position: relative;
    }
    .SaaSXITONGBOX {
      
      position: relative;
      max-width: 1200px;
      margin: 0 auto;
      margin-top: 30px;
      height: 562px;
      .sl {
        width: 30%;
        .slitem::before{
          position: absolute;
          right: -10px;
          top: 55px;
          border-top: 6px solid transparent;
          border-bottom: 6px solid transparent;
          border-left: 10px solid #ff7f50;
        }
        
        .slitem {
          margin-bottom: 20px;
          // height: 120px;
          width: calc(100% - 20px);
          position: relative;
          background: #fff;
          padding-left: 20px;
          padding-bottom: 20px;
          padding-right: 20px;
          color: #333333;
          box-sizing: border-box;
          
          .sl01 {
            width: 68px;
            height: 78px;
          }
          .sl02 {
            width: 89px;
            height: 78px;
          }
          .sl03 {
            width: 87px;
            height: 78px;
          }
          .sltop {
            width: 360px;
            height: 120px;
            position: absolute;
            top: 0;
            left: 0;
          }
          .p1 {
            font-size: 18px;
            font-weight: 400;
            
            line-height: 28px;
          }
        }
        .slsjx{
          color: #ffffff;
          background: #ff7f50;
        }
        .slsjx::before{
          content:'';
          position: absolute;
          right: -14px;
          top: 50%;
          transform: translate(-50%,0);
          border-top: 6px solid transparent;
          border-bottom: 6px solid transparent;
          border-left: 10px solid #ff7f50;
        }
        
      }

      .sr {
        width: 70%;
        .srbox{
          width: 100%;
          height: 380px;
          background: #FFFFFF;
          border-radius: 0px 50px 0px 50px;
          opacity: 1;
          overflow: hidden;

        }
        .srcontent{
          margin-top: 20px;
          background: #FFFFFF;
          border-radius: 20px 20px 20px 20px;
          padding: 25px 30px;
          width: 100%;
          min-height: 162px;
          box-sizing: border-box;
          .p1{
            font-size: 20px;
            font-weight: bold;
            color: #333333;
            line-height: 26px;
          }
          .p2{
            margin-top: 20px;
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            line-height: 32px;
          }
        }
      }
    }
  }
  .SaaStitle {
    width: 100%;
    .p1 {
      margin-top: 50px;
      font-size: 26px;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
    }
    .p2 {
      margin-top: 10px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 21px;
    }
  }
  .Cardtop {
    width: 1200px;
    height: 720px;
    margin: 30px auto 0;
    position: relative;
    .cardbg1 {
      width: 1200px;
      height: 623px;
      position: absolute;
      left: 0;
      bottom: 0;
    }

    .Cardbox {
      width: 750px;
      height: 392px;
      background: #ffffff;
      box-shadow: 0px -4px 20px 1px rgba(0, 0, 0, 0.03);
      position: relative;
      margin-left: 150px;
      .cardbg2 {
        width: 710px;
        height: 250px;
        margin-top: 20px;
      }
      .Cardboxtext {
        width: 100%;
        height: 122px;
        padding: 20px;
        .p1 {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          line-height: 24px;
          margin-bottom: 15px;
        }
        .p2 {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
      }
    }

    .Cardlist {
      margin-top: 30px;
      position: relative;
      padding: 0 30px;
      .Carditem {
        cursor: pointer;
        width: 370px;
        height: 270px;
        background: #ffffff;
        box-shadow: 0px -4px 20px 1px rgba(0, 0, 0, 0.03);
        position: relative;
        // margin-left: 150px;
        .cardbg2 {
          width: 330px;
          height: 120px;
          margin-top: 20px;
        }
        .Cardboxtext {
          width: 100%;
          height: 130px;
          padding: 15px 10px 15px 20px;
          .p1 {
            font-size: 14px;
            font-weight: bold;
            color: #333333;
            line-height: 24px;
            margin-bottom: 10px;
          }
          .p2 {
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
          }
        }
      }
    }
  }

  .Cardfooter {
    max-width: 1200px;
    margin: 30px auto;
    position: relative;
    .Cardleft {
      width: 50%;
      height: 730px;
      .Cardt {
        width: 100%;
      }

      .Cardbottom-l {
        width: 50%;
        height: 480px;
      }
      .Cardbottom-r {
        width: 50%;
        height: 480px;
      }
      .Carditem2 {
        width: 100%;
        height: 480px;
        position: relative;
        .Cardfooterimg {
          width: 100%;
          height: 480px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .CardfooterMask {
          width: 100%;
          height: 480px;
          position: absolute;
          top: 0;
          left: 0;
          // background: rgba(51, 51, 51, 0.5);
          > p {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
      .Carditem {
        width: 100%;
        height: 230px;
        position: relative;
        .Cardfooterimg {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .CardfooterMask {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(51, 51, 51, 0.5);
          > p {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
    }
    .Cardright {
      width: 50%;
      height: 730px;
      .Cardt {
        width: 100%;
      }

      .Cardbottom {
        width: 100%;
        height: 480px;
      }

      .Cardbottom-l {
        width: 100%;
        height: 230px;
      }
      .Cardbottom-r {
        width: 100%;
        height: 230px;
      }
      .Carditem3 {
        width: 100%;
        height: 230px;
        position: relative;
        .Cardfooterimg {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .CardfooterMask {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(51, 51, 51, 0.5);
          > p {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
      .Carditem2 {
        width: 100%;
        height: 480px;
        position: relative;
        .Cardfooterimg {
          width: 100%;
          height: 480px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .CardfooterMask {
          width: 100%;
          height: 480px;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(51, 51, 51, 0.5);
          > p {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
      .Carditem {
        width: 100%;
        height: 230px;
        position: relative;
        .Cardfooterimg {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .CardfooterMask {
          width: 100%;
          height: 230px;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(51, 51, 51, 0.5);
          > p {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
          }
        }
      }
    }
  }
}
.SaaSfooter {
  margin-top: 50px;
  width: 100%;
  position: relative;
  .fimg {
    width: 100%;
    height: 200px;
  }
  .SaaSfl {
    position: relative;
    width: 50%;
    height: 150px;
    .SaaSflimg {
      width: 100%;
      height: 150px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .pp {
      height: 24px;
      font-size: 18px;
      font-weight: bold;
      color: #ffffff;
      line-height: 24px;
      margin-top: 32px;
      position: relative;
    }

    .SaaSflbox {
      position: relative;
      height: 45px;
      width: 510px;
      margin-top: 20px;
      .sline {
        margin: 0 10px 0 6px;
        font-size: 20px;
        font-weight: 400;
        color: #ffd1a3;
        line-height: 45px;
        width: 2px;
        height: 28px;
        opacity: 1;
        // background-color: #ffffff;
      }
      .SaaSflitem {
        height: 45px;
        .p1 {
          margin-left: 5px;
          font-size: 24px;
          font-weight: 400;
          color: #ffffff;
          line-height: 45px;
        }
        .p2 {
          margin-left: 5px;
          font-size: 24px;
          font-weight: 400;
          color: #ffffff;
          line-height: 45px;
        }
      }
    }
  }
  .SaaSfr {
    position: relative;
    width: 50%;
    height: 150px;
    .SaaSfrimg {
      width: 100%;
      height: 150px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}
.paddingfix {
  padding-top: 0 !important;
}
</style>
<style>
.hover-search-fix {
  width: 100%;
  height: 74px;
}
.hover-search {
  width: 100%;
  height: 74px;
  transform: translateY(-200px);
  background-color: #fff;
  position: fixed;
  top: 0;
  z-index: 9999;
  box-shadow: 0 0 10px 2px rgb(90 90 90 / 60%);
  /* transition: 0.35s; */
}
.show {
  transform: translateY(0);
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
  top: 0;
}
.SaaSbanner .ivu-carousel-dots-inside {
  bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/jtjc/CloudSaaS4.vue